/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AuthorizationRequestForMobileDto,
  AuthorizationRequestForWebDto,
  CreateAuthorizationRequestDto,
  UserLoginToOrgRequestDto,
  UsernamePasswordDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class MobileAuthorizationController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags mobile-authorization-controller
   * @name CreateAuthorizationRequestForWeb
   * @request POST:/api/web/authorization/request
   */
  createAuthorizationRequestForWeb = (
    data: CreateAuthorizationRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<AuthorizationRequestForWebDto, any>({
      path: `/web/authorization/request`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createAuthorizationRequestForWebPath = '/web/authorization/request'
  static createAuthorizationRequestForWebMethod = 'POST'
  /**
   * No description
   *
   * @tags mobile-authorization-controller
   * @name LoginRequestForMobile
   * @request POST:/api/web/authorization/login
   */
  loginRequestForMobile = (data: UserLoginToOrgRequestDto, params: RequestParams = {}) =>
    this.http.request<UserLoginToOrgRequestDto, any>({
      path: `/web/authorization/login`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static loginRequestForMobilePath = '/web/authorization/login'
  static loginRequestForMobileMethod = 'POST'
  /**
   * No description
   *
   * @tags mobile-authorization-controller
   * @name CreateLoginRequestForWeb
   * @request POST:/api/web/authorization/login/auth
   */
  createLoginRequestForWeb = (data: UsernamePasswordDto, params: RequestParams = {}) =>
    this.http.request<AuthorizationRequestForWebDto, any>({
      path: `/web/authorization/login/auth`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createLoginRequestForWebPath = '/web/authorization/login/auth'
  static createLoginRequestForWebMethod = 'POST'
  /**
   * No description
   *
   * @tags mobile-authorization-controller
   * @name FindLoginRequestForWebUnauthorizedWithPassword
   * @request POST:/api/web/authorization/login/auth/{authId}
   */
  findLoginRequestForWebUnauthorizedWithPassword = (
    authId: string,
    data: UsernamePasswordDto,
    params: RequestParams = {},
  ) =>
    this.http.request<AuthorizationRequestForWebDto, any>({
      path: `/web/authorization/login/auth/${authId}`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static findLoginRequestForWebUnauthorizedWithPasswordPath =
    '/web/authorization/login/auth/${authId}'
  static findLoginRequestForWebUnauthorizedWithPasswordMethod = 'POST'
  /**
   * No description
   *
   * @tags mobile-authorization-controller
   * @name MarkLoginAsRejectedFromWeb
   * @request DELETE:/api/web/authorization/login/auth/{authId}
   */
  markLoginAsRejectedFromWeb = (authId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/web/authorization/login/auth/${authId}`,
      method: 'DELETE',
      ...params,
    })

  static markLoginAsRejectedFromWebPath = '/web/authorization/login/auth/${authId}'
  static markLoginAsRejectedFromWebMethod = 'DELETE'
  /**
   * No description
   *
   * @tags mobile-authorization-controller
   * @name FindAuthorizationRequestForMobile
   * @request GET:/api/m/authorization/request
   */
  findAuthorizationRequestForMobile = (params: RequestParams = {}) =>
    this.http.request<AuthorizationRequestForMobileDto, any>({
      path: `/m/authorization/request`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findAuthorizationRequestForMobilePath = '/m/authorization/request'
  static findAuthorizationRequestForMobileMethod = 'GET'
  /**
   * No description
   *
   * @tags mobile-authorization-controller
   * @name CreateAuthorizationRequestForMobile
   * @request POST:/api/m/authorization/request
   */
  createAuthorizationRequestForMobile = (
    data: CreateAuthorizationRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<AuthorizationRequestForMobileDto, any>({
      path: `/m/authorization/request`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createAuthorizationRequestForMobilePath = '/m/authorization/request'
  static createAuthorizationRequestForMobileMethod = 'POST'
  /**
   * No description
   *
   * @tags mobile-authorization-controller
   * @name FindAuthorizationRequestForWeb
   * @request GET:/api/web/authorization/request/{authId}
   */
  findAuthorizationRequestForWeb = (authId: string, params: RequestParams = {}) =>
    this.http.request<AuthorizationRequestForWebDto, any>({
      path: `/web/authorization/request/${authId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findAuthorizationRequestForWebPath = '/web/authorization/request/${authId}'
  static findAuthorizationRequestForWebMethod = 'GET'
  /**
   * No description
   *
   * @tags mobile-authorization-controller
   * @name MarkAuthorizationAsRejectedFromWeb
   * @request DELETE:/api/web/authorization/request/{authId}
   */
  markAuthorizationAsRejectedFromWeb = (authId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/web/authorization/request/${authId}`,
      method: 'DELETE',
      ...params,
    })

  static markAuthorizationAsRejectedFromWebPath = '/web/authorization/request/${authId}'
  static markAuthorizationAsRejectedFromWebMethod = 'DELETE'
  /**
   * No description
   *
   * @tags mobile-authorization-controller
   * @name MarkAuthorizationAsRejectedFromMobile
   * @request DELETE:/api/m/authorization/request/{authId}
   */
  markAuthorizationAsRejectedFromMobile = (authId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/m/authorization/request/${authId}`,
      method: 'DELETE',
      ...params,
    })

  static markAuthorizationAsRejectedFromMobilePath = '/m/authorization/request/${authId}'
  static markAuthorizationAsRejectedFromMobileMethod = 'DELETE'
}
